'use es6';

import { apiClientProvider } from '../utils/apiClient';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
let apiBase = 'ecosystem/v1';
export const setEcosystemApiBase = base => {
  apiBase = base;
};
export const fetchProfileReviewSummary = apiClientProvider((apiClient, profileId) => apiClient.get(`${apiBase}/reviews/summaries?type=${ReviewTypes.PROFILE}&entityIds=${profileId}`));
export const fetchIntegrations = apiClientProvider(apiClient => apiClient.get(`${apiBase}/offerings/summaries?offeringType=APP`));